import { writable } from 'svelte/store';

let siteText            = 'Imobiliária Zimmer';
let siteDescription     = 'Imobiliária - Porto Alegre - RS';

export let tagsSEO      = writable('Administração de condomínios,<br class="hidden-sm hidden-xs"/> aluguel, compra e venda de imóveis<br class="hidden-sm hidden-xs"/> em Porto Alegre - RS<br class="hidden-sm hidden-xs"/> desde 1999.');

export const alt				= writable(siteText);
export const headerTitleHome	= writable(siteText + " | " + siteDescription);
export const headerTitle		= writable("| " + siteText);
export const textSite			= writable(siteText);

export const ntRent			= writable('1');
export const ntSell			= writable('2');
export const ntSeason		= writable('0');

// E-mails
export const mailAtendimento	= writable("siteatendimento@aplicativozimmer.com.br");
export const mailLocacao		= writable("sitelocacao@aplicativozimmer.com.br");
export const mailVendas			= writable("sitevendas@aplicativozimmer.com.br");
export const mailOuvidoria		= writable("siteouvidoria@aplicativozimmer.com.br");
export const mailRH				= writable("siteatendimento@aplicativozimmer.com.br");
export const mailLista			= writable("siteatendimento@aplicativozimmer.com.br");
export const mailAtualize		= writable("siteatendimento@aplicativozimmer.com.br");
export const mailCadastro		= writable("siteatendimento@aplicativozimmer.com.br");
export const mailCondominios	= writable("sitecondominio@aplicativozimmer.com.br");
export const mailProposta		= writable("sitecondominio@aplicativozimmer.com.br");
export const mailDesocupacao	= writable("sitelocacao@aplicativozimmer.com.br");

export const textTelefoneLocacao	= writable("(51) 99468-0631");
export const linkTelefoneLocacao	= writable("https://wa.me/5551994680631");

export const whatsappLocacao		= writable("5551994680631");
export const textWhatsappLocacao	= writable("(51) 99468-0631");
export const linkWhatsappLocacao	= writable("https://wa.me/5551994680631");

export const textTelefoneVendas		= writable("(51) 99468-1831");
export const linkTelefoneVendas		= writable("https://wa.me/5551994681831");

export const whatsappVendas			= writable("5551994681831");
export const textWhatsappVendas		= writable("(51) 99468-1831");
export const linkWhatsappVendas		= writable("https://wa.me/5551994681831");

export const textTelefoneCondominio	= writable("(51) 99314-3462");
export const linkTelefoneCondominio	= writable("https://wa.me/5551993143462");

export const whatsappCondominio		= writable("5551993143462");
export const textWhatsappCondominio	= writable("(51) 99314-3462");
export const linkWhatsappCondominio	= writable("https://wa.me/5551993143462");

// Links
export const linkPesquisaLocacao	= writable("/imoveis/locacao#tipo_negociacao=1&cidade=Porto%20Alegre&ordem=1");
export const linkPesquisaVendas		= writable("/imoveis/vendas#tipo_negociacao=2&cidade=Porto%20Alegre&ordem=1");
export const linkPesquisaVendasVideo= writable("/imoveis/vendas#tipo_negociacao=2&cidade=Porto%20Alegre&recursos=$VIDEO$&ordem=1");

// Redes Sociais e Atendimento
export const linkFacebook       = writable("https://www.facebook.com/Zimmer-Assessoria-Imobili%C3%A1ria-224602474573977");
export const linkInstagram      = writable("https://www.instagram.com/imobiliariazimmer/");
export const linkYoutube        = writable("");
export const linkTwitter        = writable("");
export const linkLinkedin       = writable("https://www.linkedin.com/company/imobiliariazimmer");
export const linkBlog	        = writable("https://blog.imobiliariazimmer.com.br/");

export const linkMapa           = writable("https://goo.gl/maps/i5pUeCJSnjsmWpnh7");
export const linkWaze           = writable("https://www.waze.com/ul?place=ChIJ9WFFSiJ4GZUR5srXyftGRBQ&ll=-30.04353470%2C-51.18616770&navigate=yes");
export const linkUber           = writable("https://m.uber.com/ul/?action=setPickup&client_id=9zzPwceWa0hEu1fLOgKkUoEp0EmIVgjH&pickup=my_location&dropoff[formatted_address]=Zimmer%20Assessoria%20Imobili%C3%A1ria%20-%20Avenida%20Prot%C3%A1sio%20Alves%20-%20Petr%C3%B3polis%2C%20Porto%20Alegre%20-%20RS%2C%20Brasil&dropoff[latitude]=-30.043535&dropoff[longitude]=-51.186168");
export const linkIframeMapa     = writable("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3453.767407827579!2d-51.18874262363887!3d-30.043530031235555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951978224a4561f5%3A0x144446fbc9d7cae6!2sZimmer%20Assessoria%20Imobili%C3%A1ria!5e0!3m2!1spt-BR!2sbr!4v1683569302231!5m2!1spt-BR!2sbr");


export const linkAPI            = writable("http://www.api.com.br");
export const linkAV             = writable("https://www.imobiliariazimmer.com.br/zimmerdigital/");
export const linkAV2    		= writable("https://www.imobiliariazimmer.com.br/zimmerdigital/");
export const linkAreaCliente	= writable("https://www.imobiliariazimmer.com.br/zimmerdigital/");
export const linkConheca        = writable("https://imobiliariazimmer.com.br/conheca");
export const linkSolicite       = writable("https://www.imobiliariazimmer.com.br/zimmerdigital/");
export const linkBoletoFacil    = writable("https://www.imobiliariazimmer.com.br/zimmerdigital/login?boleto-facil=1");

export const textAtendimento            = writable('De Segunda à Sexta, das 9h às 17h');
export const textEndereco               = writable('Av. Protásio Alves, 2306 - Petrópolis,<br class="hidden-sm hidden-xs"/> Porto Alegre - RS, CEP: 90410-006');
export const textCNPJ                   = writable("03.348.407/0001-00");
export const textCreci                  = writable("22128-J");

export const linkPoliticaPrivacidade	= writable("/assets/files/PoliticaDePrivacidade.pdf");
export const linkPoliticaCookies		= writable("/assets/files/PoliticaDePrivacidade.pdf");

export const textPoliticaCheck 			= writable("Aceito compartilhar meus dados de acordo com a <a href='/assets/files/PoliticaDePrivacidade.pdf' target='_blank'>Política de Privacidade</a> da Zimmer. Estou ciente e concordo em receber todas as comunicações relativas ao meu cadastro, incluindo comunicados, informações e promoções.");

export const todosContatos = writable([
	{
		title: 'Atendimento',
		icon: '<i class="fas fa-phone"></i>',
		href: 'tel://555133884913',
		target: '_blank',
		phone: '(51) 3388-4913',
		email: 'siteatendimento@aplicativozimmer.com.br'
	},
	{
		title: 'Condomínios',
		icon: '<i class="fab fa-whatsapp"></i>',
		href: 'https://wa.me/5551993143462 ',
		target: '_blank',
		phone: '(51) 99314-3462',
		email: 'sitecondominio@aplicativozimmer.com.br'
	},
	{
		title: 'Locação',
		icon: '<i class="fab fa-whatsapp"></i>',
		href: 'https://wa.me/5551994680631 ',
		target: '_blank',
		phone: '(51) 99468-0631',
		email: 'sitelocacao@aplicativozimmer.com.br'
	},
	{
		title: 'Vendas',
		icon: '<i class="fab fa-whatsapp"></i>',
		href: 'https://wa.me/5551994681831 ',
		target: '_blank',
		phone: '(51) 99468-1831',
		email: 'sitevendas@aplicativozimmer.com.br'
	}
]);

export const propostaContatos = writable([
	{
		title: 'Atendimento',
		icon: '<i class="fas fa-phone"></i>',
		href: 'tel://555133884913',
		target: '_blank',
		phone: '(51) 3388-4913',
		email: 'siteatendimento@aplicativozimmer.com.br'
	},
	{
		title: 'Condomínios',
		icon: '<i class="fab fa-whatsapp"></i>',
		href: 'https://wa.me/5551993143462 ',
		target: '_blank',
		phone: '(51) 99314-3462',
		email: 'sitecondominio@aplicativozimmer.com.br'
	},
	{
		title: 'Locação',
		icon: '<i class="fab fa-whatsapp"></i>',
		href: 'https://wa.me/5551994680631 ',
		target: '_blank',
		phone: '(51) 99468-0631',
		email: 'sitelocacao@aplicativozimmer.com.br'
	},
	{
		title: 'Vendas',
		icon: '<i class="fab fa-whatsapp"></i>',
		href: 'https://wa.me/5551994681831 ',
		target: '_blank',
		phone: '(51) 99468-1831',
		email: 'sitevendas@aplicativozimmer.com.br'
	}
]);

export const comoChegar = writable([
	{
		title: 'Mapa',
		icon: '<i class="fas fa-map-marked-alt"></i>',
		link: 'https://goo.gl/maps/i5pUeCJSnjsmWpnh7',
	},
	{
		title: 'Waze',
		icon: '<i class="fab fa-waze"></i>',
		link: 'https://www.waze.com/ul?place=ChIJ9WFFSiJ4GZUR5srXyftGRBQ&ll=-30.04353470%2C-51.18616770&navigate=yes',
	},
	{
		title: 'Uber',
		icon: '<i class="fab fa-uber"></i>',
		link: 'https://m.uber.com/ul/?action=setPickup&client_id=9zzPwceWa0hEu1fLOgKkUoEp0EmIVgjH&pickup=my_location&dropoff[formatted_address]=Zimmer%20Assessoria%20Imobili%C3%A1ria%20-%20Avenida%20Prot%C3%A1sio%20Alves%20-%20Petr%C3%B3polis%2C%20Porto%20Alegre%20-%20RS%2C%20Brasil&dropoff[latitude]=-30.043535&dropoff[longitude]=-51.186168',
	}
]);

export const social = writable([
	{
		title: 'Facebook',
		icon: '<i class="fab fa-fw fa-facebook-square"></i>',
		link: 'https://www.facebook.com/Zimmer-Assessoria-Imobili%C3%A1ria-224602474573977',
		target: '_blank',
	},
	{
		title: 'Instagram',
		icon: '<i class="fab fa-fw fa-instagram"></i>',
		link: 'https://www.instagram.com/imobiliariazimmer/',
		target: '_blank',
	},
	{
		title: 'Linkedin',
		icon: '<i class="fab fa-fw fa-linkedin"></i>',
		link: 'https://www.linkedin.com/company/imobiliariazimmer',
		target: '_blank',
	}
]);